import type {
	SubscribeToNewsletterRecaptchaMutation,
	SubscribeToNewsletterRecaptchaMutationVariables,
} from '../../mutations/__generated__/subscribeToNewsletterRecaptcha.generated';

/**
 * Sends the `subscribeToNewsletterRecaptcha` GraphQL mutation, loading the GraphQL client and the
 * query document on first use.
 *
 * WHY: the newsletter form sits in every page's footer, and importing the
 * client up front put `graphql` and `graphql-request` (~55 KiB raw) in the
 * scripts every page preloads, for a form few visitors submit.
 */
export const subscribeToNewsletterRecaptcha = async (
	variables: SubscribeToNewsletterRecaptchaMutationVariables
): Promise<SubscribeToNewsletterRecaptchaMutation> => {
	const [{ getMutation }, { SubscribeToNewsletterRecaptchaDocument }] =
		await Promise.all([
			import('#lib/query-utils/getMutation.js'),
			import('../../mutations/__generated__/subscribeToNewsletterRecaptcha.generated'),
		]);

	return getMutation(SubscribeToNewsletterRecaptchaDocument).mutationFn(
		variables
	);
};
